import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader'; // If using react-spinners

const Loader = () => {
  return (
    <div style={loaderOverlayStyle}>
      <ClipLoader size={60} color="#3498db" />
    </div>
  );
};

const loaderOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 999999,
};

export default Loader;
